import request from '@/utils/request'

// 登录方法
export function login(uuid) {
  return request({
    url: '/temporary-login/'+uuid,
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post'
  })
}

// 获取用户信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}
